import { Component, Input, ViewChild } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { Currency, FxService } from 'src/app/services/fx.service';

@Component({
  selector: 'itfg-currency-toggle',
  templateUrl: './currency-toggle.component.html',
  styleUrls: ['./currency-toggle.component.scss'],
  standalone: false,
})
export class CurrencyToggleComponent {
  @Input() tooltipPosition: 'above' | 'below' | 'left' | 'right' = 'right';
  @ViewChild(MatTooltip) tooltip!: MatTooltip;

  get isBGN(): boolean {
    return this.fxService.displayCurrency() === Currency.BGN;
  }

  constructor(private fxService: FxService) {}

  toggle(): void {
    this.fxService.toggleCurrency();

    if (this.tooltip) {
      this.tooltip.hide();
      setTimeout(() => {
        if (this.tooltip) {
          this.tooltip.show();
        }
      }, 100);
    }
  }
}
